import { React, useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Tabs, Tab } from 'react-bootstrap';
import DocList from './DocList/DocList';
import RefreshDocList from './DocList/RefreshDocList';
import ProfileTabs from './ProfileTabs';
import TagsWithFilters from './TagsWithFilters'

const TabProfileGroup = ({ profiles, name, title, path }) => {
  const newsProfile = profiles.news;
  const cveProfile = profiles.cve;
  const podcastProfile = profiles.podcasts;
  const mitreProfile = profiles.mitre;

  const routes = useMemo(
    () => ({
      [name]: {
        podcasts: `/${name}/podcasts`,
        news: `/${name}/news`,
        cve: `/${name}/cve`,
        mitre: `/${name}/mitre`,
        workspaces: `/${name}/workspaces`,
      },
    }),
    [name]
  );

  const navigate = useNavigate();

  const [activeGroupKey, setActiveGroupKey] = useState(`news`);
  const [activeSubCveKey, setActiveSubCveKey] = useState('recommendations');
  const [activeSubNewsKey, setActiveSubNewsKey] = useState('recommendations');

  useEffect(() => {
    if (path.includes(routes[name].news)) {
      setActiveGroupKey('news');
    } else if (path.includes(routes[name].podcasts)) {
      setActiveGroupKey('podcasts');
    } else if (path.includes(routes[name].cve)) {
      setActiveGroupKey('cve');
    } else if (path.includes(routes[name].mitre)) {
      setActiveGroupKey('mitre');
    } else if (path.includes(routes[name].workspaces)) {
      setActiveGroupKey('workspaces');
    }
  }, [path, name, routes]);
  const secondaryProfiles = (repo) => {
    if (repo === 'news') {
      const profileForNews = [];
      if (podcastProfile) profileForNews.push(podcastProfile);
      if (cveProfile) profileForNews.push(cveProfile);
      if (mitreProfile) profileForNews.push(mitreProfile);
      return profileForNews;
    } else if (repo === 'podcasts') {
      const profileForPodcasts = [];
      if (newsProfile) profileForPodcasts.push(newsProfile);
      if (cveProfile) profileForPodcasts.push(cveProfile);
      if (mitreProfile) profileForPodcasts.push(mitreProfile);
      return profileForPodcasts;
    }
    return null;
  };
  const profile = profiles[activeGroupKey];

  return (
    <div className='tab-group tab-public-group m-0' data-testid='news-wrapper'>
      <Row>
        <Col md={12}>
          <h3 className='mytools_heading'>The State of Cybersecurity</h3>
          <Row>
            <Col md={12}>
              {(profile?.roles.indexOf('curator') > -1 &&
                ((activeGroupKey === 'news' && activeSubNewsKey === 'recommendations') ||
                  (activeGroupKey === 'podcasts' && activeSubNewsKey === 'recommendations') ||
                  (activeGroupKey === 'cve' && activeSubCveKey === 'recommendations'))) && <TagsWithFilters showTools={false} profileKey={activeGroupKey} profiles={profiles} name={name} activeGroupKey={activeGroupKey} />}
            </Col>
          </Row>

          <div className='position-relative '>
            <RefreshDocList />
            {(newsProfile.roles.indexOf('curator') > -1 && cveProfile.roles.indexOf('curator') > -1 && podcastProfile.roles.indexOf('curator') > -1) ?
              <ProfileTabs
                newsProfile={newsProfile}
                podcastProfile={podcastProfile}
                cveProfile={cveProfile}
                mitreProfile={mitreProfile}
                routes={routes}
                name={name}
                activeGroupKey={activeGroupKey}
                activeSubNewsKey={activeSubNewsKey}
                setActiveSubNewsKey={setActiveSubNewsKey}
                activeSubCveKey={activeSubCveKey}
                setActiveSubCveKey={setActiveSubCveKey}
              />
              :
              <Tabs
                defaultActiveKey='news'
                className='nav nav-tabs nav-tabs-second-level'
                activeKey={activeGroupKey}
                onSelect={(k) => navigate(`${routes[name][k]}`)}
              >
                <Tab eventKey='news' title='News' data-testid='news-tab-panel'>
                  {newsProfile &&
                    newsProfile.profileId &&
                    activeGroupKey === 'news' && (
                      <DocList
                        key={`news-watchlist-${newsProfile.profileId}`}
                        profilePrimary={newsProfile}
                        activeGroupKey={activeGroupKey}
                        profileSecondary={secondaryProfiles('news')}
                        list='watchlist'
                        showAddWatchList={false}
                        showRemove={newsProfile.roles.indexOf('curator') > -1}
                      />
                    )}
                </Tab>
                <Tab
                  eventKey='podcasts'
                  title='Podcasts'
                  data-testid='podcasts-tab-panel'
                >
                  {podcastProfile &&
                    podcastProfile.profileId &&
                    activeGroupKey === 'podcasts' && (
                      <DocList
                        key={`podcasts-watchlist-${podcastProfile.profileId}`}
                        profilePrimary={podcastProfile}
                        activeGroupKey={activeGroupKey}
                        profileSecondary={secondaryProfiles('podcasts')}
                        list='watchlist'
                        showAddWatchList={false}
                        showRemove={podcastProfile.roles.indexOf('curator') > -1}
                      />
                    )}
                </Tab>
                {/* <Tab
              eventKey='workspaces'
              title='Workspaces'
              data-testid='workspaces-tab-panel'
            >
              {activeGroupKey === 'workspaces' && (
                <Tabs
                  defaultActiveKey='log4j'
                  className='nav nav-tabs nav-tabs-third-level'
                >
                  <Tab
                    eventKey='log4j'
                    title='Log4J'
                    data-testid='log4j-tab-panel'
                  >
                    <Tabs
                      defaultActiveKey='log4j_news'
                      className='nav nav-tabs nav-tabs-fourth-level'
                    >
                      {profiles.wksp_log4j_news && (
                        <Tab
                          eventKey='log4j_news'
                          title='News'
                          data-testid='log4j-news-tab-panel'
                        >
                          <DocList
                            key={`log4j-news-watchlist-${profiles.wksp_log4j_news.profileId}`}
                            profilePrimary={profiles.wksp_log4j_news}
                            profileSecondary={[
                              profiles.wksp_log4j_podcasts,
                              profiles.wksp_log4j_cve,
                              profiles.wksp_log4j_mitre,
                            ]}
                            list='watchlist'
                            showAddWatchList={
                              profiles.wksp_log4j_news.roles.indexOf(
                                'curator'
                              ) > -1
                            }
                            showRemove={
                              profiles.wksp_log4j_news.roles.indexOf(
                                'curator'
                              ) > -1
                            }
                          />
                        </Tab>
                      )}
                      {profiles.wksp_log4j_cve && (
                        <Tab
                          eventKey='log4j_cve'
                          title='CVEs'
                          data-testid='log4j-cve-tab-panel'
                        >
                          <DocList
                            key={`log4j-cve-watchlist-${profiles.wksp_log4j_cve.profileId}`}
                            profilePrimary={profiles.wksp_log4j_cve}
                            profileSecondary={[
                              profiles.wksp_log4j_news,
                              profiles.wksp_log4j_podcasts,
                              profiles.wksp_log4j_mitre,
                            ]}
                            list='watchlist'
                            showAddWatchList={
                              profiles.wksp_log4j_cve.roles.indexOf('curator') >
                              -1
                            }
                            showRemove={
                              profiles.wksp_log4j_cve.roles.indexOf('curator') >
                              -1
                            }
                          />
                        </Tab>
                      )}
                      {profiles.wksp_log4j_podcasts && (
                        <Tab
                          eventKey='log4j_podcast'
                          title='Podcast'
                          data-testid='log4j-podcast-tab-panel'
                        >
                          <DocList
                            key={`log4j-podcast-watchlist-${profiles.wksp_log4j_podcasts.profileId}`}
                            profilePrimary={profiles.wksp_log4j_podcasts}
                            profileSecondary={[
                              profiles.wksp_log4j_news,
                              profiles.wksp_log4j_cve,
                              profiles.wksp_log4j_mitre,
                            ]}
                            list='watchlist'
                            showAddWatchList={
                              profiles.wksp_log4j_podcasts.roles.indexOf(
                                'curator'
                              ) > -1
                            }
                            showRemove={
                              profiles.wksp_log4j_podcasts.roles.indexOf(
                                'curator'
                              ) > -1
                            }
                          />
                        </Tab>
                      )}
                      {profiles.wksp_log4j_mitre && (
                        <Tab
                          eventKey='log4j_mitre'
                          title='Mitre ATT&CK'
                          data-testid='log4j-mitre-tab-panel'
                        >
                          <DocList
                            key={`log4j-mitre-watchlist-${profiles.wksp_log4j_mitre.profileId}`}
                            profilePrimary={profiles.wksp_log4j_mitre}
                            profileSecondary={[
                              profiles.wksp_log4j_news,
                              profiles.wksp_log4j_podcasts,
                              profiles.wksp_log4j_cve,
                            ]}
                            list='watchlist'
                            showAddWatchList={
                              profiles.wksp_log4j_mitre.roles.indexOf(
                                'curator'
                              ) > -1
                            }
                            showRemove={
                              profiles.wksp_log4j_mitre.roles.indexOf(
                                'curator'
                              ) > -1
                            }
                          />
                        </Tab>
                      )}
                    </Tabs>
                  </Tab>
                </Tabs>
              )}
            </Tab> */}
              </Tabs>
            }
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TabProfileGroup;
